import MisRecetasComponent from "../components/MisRecetas/MisRecetas";
export default function MisRecetas() {
  return <MisRecetasComponent />;
}
